import React from "react";
import { Stack } from "@mui/material";
import { categories } from "../utils/constants";

const Categories = ({ selectedCategory, setSelectedCategory }) => (
  <Stack
    direction="row"
    sx={{
      overflowY: "auto",
      height: { sx: "auto", md: "95%" },
      flexDirection: { md: "column" },
    }}
  >
    {categories.map((category) => (
      // Category Name
      <button
        className="category-btn"
        onClick={() => setSelectedCategory(category.name)}
        style={{
          background: category.name === selectedCategory && "#1075ec",
          color: "white",
        }}
        key={category.name}
      >
        {/* Category icon */}
        <span style={{ color: category.name === selectedCategory ? "white" : "paleturquoise", marginRight: "15px" }}>
          {category.icon}
        </span>
        {/* Category Name */}
        <span style={{ opacity: category.name === selectedCategory ? "1" : "0.8" }}>
          {category.name}
        </span>
      </button>
    ))}
  </Stack>
);

export default Categories;
